/**
 * 单车T0的一些下拉数据
 */

const bikePersonData = {
  data() {
    return {
      actionTypeList: [], // 动作类型
      workTaskTypeList: [] // 业务类型
    }
  },

  created() {
    this.getBikeActionList()
    this.getBikeTaskTypeList()
  },

  computed: {
    bikeActionMap() {
      let tmpMap = {}
      this.actionTypeList.map(item => {
        tmpMap[item.actionType] = item.actionName
      })
      return tmpMap
    },

    bikeWorkTypeMap() {
      let tmpMap = {}
      this.workTaskTypeList.map(item => {
        tmpMap[item.id] = item.text
      })
      return tmpMap
    }
  },

  methods: {
    getBikeActionList() {
      this.fetch
        .get('getActionTypeList')
        .then(res => {
          this.actionTypeList = res.data || []
        })
        .catch(res => {
          this.actionTypeList = []
          this.$message.error(res.errMsg)
        })
    },
    // 单车业务类型 
    getBikeTaskTypeList() {
      this.fetch
        .post('getBikeTaskTypeList')
        .then(res => {
          this.workTaskTypeList = res.data || []
        })
        .catch(res => {
          this.workTaskTypeList = []
          this.$message.error(res.errMsg)
        })
    }
  }
}

export default bikePersonData
